<template>
  <svg
    :class="className"
    width="55"
    height="55"
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8952 45.833C11.4195 45.833 8.45025 44.6299 5.98747 42.2236C3.52317 39.8174 2.29102 36.8764 2.29102 33.4007C2.29102 30.4215 3.18859 27.767 4.98372 25.4372C6.77886 23.1073 9.12782 21.6177 12.0306 20.9684C12.6799 18.2184 14.3032 15.6021 16.9004 13.1195C19.4976 10.6368 22.2667 9.39551 25.2077 9.39551C26.4681 9.39551 27.5475 9.84391 28.4458 10.7407C29.3426 11.639 29.791 12.7184 29.791 13.9788V27.8434L33.4577 24.2913L36.666 27.4997L27.4994 36.6663L18.3327 27.4997L21.541 24.2913L25.2077 27.8434V13.9788C22.3049 14.5136 20.0514 15.9168 18.4473 18.1886C16.8431 20.462 16.041 22.8018 16.041 25.208H14.8952C12.6799 25.208 10.7893 25.991 9.22331 27.557C7.65734 29.1229 6.87435 31.0136 6.87435 33.2288C6.87435 35.4441 7.65734 37.3347 9.22331 38.9007C10.7893 40.4667 12.6799 41.2497 14.8952 41.2497H42.3952C43.9994 41.2497 45.3553 40.6958 46.4629 39.5882C47.5705 38.4806 48.1244 37.1247 48.1244 35.5205C48.1244 33.9163 47.5705 32.5604 46.4629 31.4528C45.3553 30.3452 43.9994 29.7913 42.3952 29.7913H38.9577V25.208C38.9577 23.3747 38.5376 21.6651 37.6973 20.0793C36.857 18.495 35.7494 17.149 34.3744 16.0413V10.7132C37.2007 12.05 39.4351 14.027 41.0775 16.644C42.7198 19.2596 43.541 22.1143 43.541 25.208C46.1764 25.5136 48.3635 26.6495 50.1021 28.6157C51.8391 30.5835 52.7077 32.8851 52.7077 35.5205C52.7077 38.3851 51.7055 40.8204 49.701 42.8263C47.695 44.8308 45.2598 45.833 42.3952 45.833H14.8952Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'ImportIcon',
  props: {
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
